import React from 'react';
import { BookMarked } from 'lucide-react';
import DataSection from '../dataSections/DataSection';

export default function PubMed() {
  return (
    <DataSection
      title="PubMed"
      icon={BookMarked}
      contentType="pub_med"
      executionUrlSuffix="pub-med"
    />
  );
}

